// LLM generated - Model Claude 4 Sonnet
import React from 'react';

interface CommissionerTagProps {
  size?: number;
}

function CommissionerTag({ size = 18 }: CommissionerTagProps) {
  const outerSize = size;
  const innerSize = size * 0.88;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_1555_6951)">
        <rect x="2" y="2" width={innerSize} height={innerSize} rx="8" fill="white" />
        <path
          d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10.0635 4.01953C7.5721 4.01957 6.16703 5.1698 6.16699 8.15625V11.8457C6.167 14.8322 7.57208 15.9824 10.0635 15.9824C12.507 15.9824 13.8649 14.8004 13.833 11.75H11.0537C11.0537 13.1074 10.8138 13.6504 10.0312 13.6504C9.39266 13.6503 9.00977 13.3464 9.00977 12.4043V7.59766C9.00977 6.65557 9.39266 6.35169 10.0312 6.35156C10.8138 6.35156 11.0537 6.89459 11.0537 8.25195H13.833C13.8649 5.20166 12.507 4.01953 10.0635 4.01953Z"
          fill="#1A1C1E"
        />
      </g>
      <rect
        x="1"
        y="1"
        width={outerSize}
        height={outerSize}
        rx="9"
        stroke="white"
        strokeWidth="2"
      />
      <defs>
        <clipPath id="clip0_1555_6951">
          <rect x="2" y="2" width={innerSize} height={innerSize} rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CommissionerTag;
